import Controller from "./station.controller";
import template from "./station.html";

const station = {
  template,
  controller: Controller,
};

export default station;



// WEBPACK FOOTER //
// ./src/pages/station/station.component.js